<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">eBASEデータ</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <wj-tab-panel #tabPanel id="tab_pCode" creationPolicy="all" id="tab_Main" [tabindex]="-1">
          <div>
            <wj-tab>
              <!-- 商品形態タブ領域 -->
              <a>商品形態</a>
              <div class="element-column">
                <table class="item-form">
                  <tr>
                    <th></th>
                    <th>ｻｲｽﾞ(縦)</th>
                    <th>ｻｲｽﾞ(横)</th>
                    <th>ｻｲｽﾞ(高)</th>
                    <th>重量</th>
                    <th>入数</th>
                  </tr>
                  <tr>
                    <td>
                      <app-radio-label label="ピース" [value]="'1'" id="rdb_Form_Piece" [subid]="'rdb_Form_Piece'"
                        #rdb_Form_Piece [forcedEnabledMode]="''" name="grp_Form" [tabindex]="0"
                        [(ngModel)]="kymw1105Model.grpForm"></app-radio-label>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeLength_Piece" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.pieceSizeLength" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeWidth_Piece" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.pieceSizeWidth" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeHeight_Piece" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.pieceSizeHeight" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_Weight_Piece" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="5"
                        [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.pieceWeight" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_ContainNum_Piece" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'" 
                        [(ngModel)]="kymw1105Model.pieceContainNum" readonly/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <app-radio-label label="パック" [value]="'2'" id="rdb_Form_Pack" [subid]="'rdb_Form_Pack'"
                        #rdb_Form_Pack [forcedEnabledMode]="''" name="grp_Form" [tabindex]="0"
                        [(ngModel)]="kymw1105Model.grpForm"></app-radio-label>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeLength_Pack" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'" 
                        [(ngModel)]="kymw1105Model.packSizeLength" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeWidth_Pack" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4"
                        [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.packSizeWidth" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeHeight_Pack" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.packSizeHeight" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_Weight_Pack" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="5"
                        [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.packWeight" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_ContainNum_Pack" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.packContainNum" readonly/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <app-radio-label label="ボール" [value]="'3'" id="rdb_Form_Bowl" [subid]="'rdb_Form_Bowl'"
                        #rdb_Form_Bowl [forcedEnabledMode]="''" name="grp_Form" [tabindex]="0"
                        [(ngModel)]="kymw1105Model.grpForm"></app-radio-label>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeLength_Bowl" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.bowlSizeLength" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeWidth_Bowl" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4"
                        [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.bowlSizeWidth" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeHeight_Bowl" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.bowlSizeHeight" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_Weight_Bowl" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="5"
                        [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.bowlWeight" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_ContainNum_Bowl" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.bowlContainNum" readonly/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <app-radio-label label="ケース" [value]="'4'" id="rdb_Form_Case" [subid]="'rdb_Form_Case'"
                        #rdb_Form_Case [forcedEnabledMode]="''" name="grp_Form" [tabindex]="0"
                        [(ngModel)]="kymw1105Model.grpForm"></app-radio-label>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeLength_Case" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.caseSizeLength" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeWidth_Case" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4"
                        [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.caseSizeWidth" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_SizeHeight_Case" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.caseSizeHeight" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_Weight_Case" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="5"
                        [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.caseWeight" readonly/>
                    </td>
                    <td>
                      <input type="text" id="txti_ContainNum_Case" plessInputTextSub [restrict]="'[0-9]'"
                        [maxlength]="4" [style.text-align]="'right'"
                        [(ngModel)]="kymw1105Model.caseContainNum" readonly/>
                    </td>
                  </tr>
                </table>

                <!-- 注釈 -->
                <label class="caution-color-bold">選択したサイズ・重量を商品マスタのピースサイズ・重量に設定します。</label>
              </div>
            </wj-tab>

            <wj-tab>
              <!-- JANコードタブ領域 -->
              <a>JANコード</a>
              <div class="element-column">
                <table class="jancode">
                  <tr>
                    <th></th>
                    <th>JANコード</th>
                  </tr>
                  <tr>
                    <td>
                      <app-radio-label label="ピース" [value]="'1'" id="rdb_JanCode_Piece" [subid]="'rdb_JanCode_Piece'"
                        [forcedEnabledMode]="''" #rdb_JanCode_Piece name="grp_JanCode" [tabindex]="0"
                        [(ngModel)]="kymw1105Model.grpJanCode">
                      </app-radio-label>
                    </td>
                    <td>
                      <input type="text" id="txti_JanCode_Piece" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="13"
                        [(ngModel)]="kymw1105Model.pieceJanCode" readonly/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <app-radio-label label="パック" [value]="'2'" id="rdb_JanCode_Pack" [subid]="'rdb_JanCode_Pack'"
                        [forcedEnabledMode]="''" #rdb_JanCode_Pack name="grp_JanCode" [tabindex]="0"
                        [(ngModel)]="kymw1105Model.grpJanCode"></app-radio-label>
                    </td>
                    <td>
                      <input type="text" id="txti_JanCode_Pack" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="13"
                        [(ngModel)]="kymw1105Model.caseJanCode" readonly/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <app-radio-label label="ボール" [value]="'3'" id="rdb_JanCode_Bowl" [subid]="'rdb_JanCode_Bowl'"
                        [forcedEnabledMode]="''" #rdb_JanCode_Bowl name="grp_JanCode" [tabindex]="0"
                        [(ngModel)]="kymw1105Model.grpJanCode"></app-radio-label>
                    </td>
                    <td>
                      <input type="text" id="txti_JanCode_Bowl" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="13"
                        [(ngModel)]="kymw1105Model.packJanCode" readonly/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <app-radio-label label="ケース" [value]="'4'" id="rdb_JanCode_Case" [subid]="'rdb_JanCode_Case'"
                        [forcedEnabledMode]="''" #rdb_JanCode_Case name="grp_JanCode" [tabindex]="0"
                        [(ngModel)]="kymw1105Model.grpJanCode">
                      </app-radio-label>
                    </td>
                    <td>
                      <input type="text" id="txti_JanCode_Case" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="13"
                        [(ngModel)]="kymw1105Model.bowlJanCode" readonly/>
                    </td>
                  </tr>
                </table>

                <!-- 注釈 -->
                <label class="caution-color-bold">選択したJANコードを商品マスタのJANコードに設定します。</label>
              </div>
            </wj-tab>

            <wj-tab>
              <!-- 工場住所タブ領域 -->
              <a>工場住所</a>
              <div class="element-column">
                <div class="column-list">
                  <label class="list-input-title">工場住所</label>
                  <div class="list-input-content">
                    <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" [maxChars]="100" id="txta_FactoryAddress" #txta_FactoryAddress
                      [subid]="'txta_FactoryAddress'" verticalScrollPolicy="on" horizontalScrollPolicy="off"
                      [editable]="false" [height]="130" [width]="'calc(100% - 5rem)'" style="display:initial;"
                      [(ngModel)]="kymw1105Model.factoryAddress" [forcedEnabledMode]="''">
                    </app-text-area>
                  </div>
                </div>

                <div>
                  <!-- 注釈 -->
                  <label class="caution-color-bold">現在入力されている「原産国加工地」に、”製造”＋「工場住所」＋”。”を連結して</label>
                  <label class="caution-color-bold">商品マスタの原産国加工地として設定します。</label>
                </div>
              </div>
            </wj-tab>
          </div>
        </wj-tab-panel>

      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Form_Set" #btn_Form_Set class="btn-primary" (click)="eventFormSetButtom_CLICKHandler()"
            forcedEnabledMode="" [style.display]="tabPanel.selectedIndex != 0 ? 'none' : ''" [tabindex]="0">設定</button>
          <button id="btn_JanCode_Set" class="btn-primary" #btn_JanCode_Set
            (click)="eventJanCodeSetButtom_CLICKHandler()" forcedEnabledMode=""
            [style.display]="tabPanel.selectedIndex != 1 ? 'none' : ''" [tabindex]="0">設定</button>
          <button id="btn_TextInfo_Set" class="btn-primary" #btn_TextInfo_Set
            (click)="eventTextInfoSetButtom_CLICKHandler()" forcedEnabledMode=""
            [style.display]="tabPanel.selectedIndex != 2 ? 'none' : ''" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
</table>